import { PATH } from 'routes/constant';
import { PRODUCT_TYPE, USER_AUTH_STATE } from './analytics';
import constant from './constant';
import UserType from 'constants/user';
import { store } from 'redux/store';
import { DynamicLayoutVersion } from '../types/types';

export interface ProductTrackingItem {
    userId: string;
    userType: string;
    productType: PRODUCT_TYPE.ITEM;
    productId: string;
    productTaffiId: string;
    productCreatorId: string;
    contextType: PRODUCT_TYPE.STYLE;
    contextId: string;
}

export interface ProductTrackingStyle {
    userId: string;
    userType: string;
    productType: PRODUCT_TYPE.STYLE;
    productId: string;
    productTaffiId: string;
    productCreatorId: string;
    contextType: '';
    contextId: '';
    sourceId: '';
}

// export const getProductTrackingData = (item: ProductTrackingItem | ProductTrackingStyle) => {
//     return (item);
// }
export const checkIsPersonalizedStyle = (item, userDetail) => {
    if (item?.consumersId) {
        return item?.consumersId?.includes(userDetail?.id);
    } else if (item?.data?.consumersId) {
        return item?.data?.consumersId?.includes(userDetail?.id);
    } else {
        return;
    }
};

const getItemStructure = (itemList) => {
    const constructItem = (itemData, index) => {
        const { id, taffiId, storeProductId, url, store, price, currency, storeUrl, taffiUrl } = itemData;
        return {
            [index]: {
                id,
                taffiId,
                taffiUrl: taffiUrl || `${process.env.REACT_APP_APP_ORIGIN}${PATH.ITEM_DETAIL}/${taffiId}`,
                storeProductId,
                storeUrl: url || storeUrl,
                price,
                currency,
                store: {
                    id: store?.id,
                    name: store?.name,
                    platform: store?.platform,
                    shopifyDomain: store?.shopifyDomain,
                    taffiId: store?.taffiId,
                    url: store?.url,
                },
            },
        };
    };
    let structuredItem = {};
    itemList.forEach((itemData, index) => {
        structuredItem = {
            ...structuredItem,
            ...constructItem(itemData?.data ? itemData?.data : itemData, index),
        };
    });
    return structuredItem;
};

export const getProductTrackingData = (userDetail, item, styleItem?, trackStyleLayoutVersion?) => {
    const isStyle =
        (item?.collection || item?.collectionName) === 'styles' ||
        item?.taffiId?.includes('STYLE-') ||
        item?.data?.taffiId?.includes('STYLE-');
    const styleLabels = item?.data?.labels
        ? item?.data?.labels?.map((label) => label?.name || '')
        : item?.style?.labels
            ? item?.style?.labels?.map((label) => label?.name || '')
            : [];
    const itemLabels = item?.labels ? item?.labels?.map((label) => label?.name || '') : [];
    const labels = isStyle ? styleLabels : itemLabels;

    let trackData: any = {
        userId: userDetail?.id,
        userType: userDetail?.userType || UserType.Customer,
        userEmail: userDetail?.email,
        productType: isStyle ? PRODUCT_TYPE.STYLE : PRODUCT_TYPE.ITEM,
        productId: String(item?.id),
        productTaffiId: item?.taffiId,
        productCreatorId: String(item?.data?.creator || item?.creator || item?.user?.id),
        contextType: isStyle ? '' : PRODUCT_TYPE.STYLE,
        contextId: isStyle ? '' : String(styleItem?.id),
        contextTaffiId: isStyle ? '' : styleItem?.taffiId,
        labels: labels,
        stylistId: isStyle ? styleItem?.user?.id : undefined,
        stylistEmail: isStyle ? styleItem?.user?.email : undefined,
        stylistName: isStyle
            ? styleItem?.user?.firstName && styleItem?.user?.firstName + ' ' + (styleItem?.user?.lastName || '')
            : undefined,
        sourceId: isStyle ? styleItem?.sourceId : '',
        userAuthState: userDetail?.id ? USER_AUTH_STATE.AUTHENTICATED : USER_AUTH_STATE.GUEST,
        productTaffiUrl: `${process.env.REACT_APP_APP_ORIGIN}${isStyle ? PATH.STYLE_DETAIL : PATH.ITEM_DETAIL}/${
            item?.taffiId
        }`,
        recommendationSource: window?.location?.pathname,
    };
    if (isStyle) {
        const items = item?.data?.items?.length ? item?.data?.items : item?.items?.length ? item?.items : [];
        let styleOnlyData = {
            ...trackData,
            items: {},
        };
        if (items?.length) {
            let structuredItem = getItemStructure(items);
            styleOnlyData = {
                ...styleOnlyData,
                items: structuredItem,
            };
        }
        let styleLayoutVersion = DynamicLayoutVersion.v1;

        if (trackStyleLayoutVersion) {
            const globalState = store.getState();
            const widgetStore = globalState.widget.store;
            const stitcher = globalState.configuration?.stitcher;
            styleLayoutVersion = widgetStore?.styleLayoutVersion
                ? widgetStore?.styleLayoutVersion === DynamicLayoutVersion.v2
                : stitcher.dynamicLayoutVersion;
        }

        trackData = { ...styleOnlyData, styleLayoutVersion };
    } else {
        trackData = {
            ...trackData,
            storeProductId: item?.storeProductId,
            storeUrl: item?.url,
            currency: item?.currency,
            price: item?.price,
            store: {
                id: item?.store?.id,
                name: item?.store?.name,
                platform: item?.store?.platform,
                shopifyDomain: item?.store?.shopifyDomain,
                taffiId: item?.store?.taffiId,
                url: item?.store?.url,
            },
        };
    }

    console.debug({ trackData });

    return trackData;
};

export const getProductTrackingDataForAmira = (user, product) => {
    const isStyle = product?.collectionName === constant.COLLECTION_NAME.STYLES;
    let trackData: any = {
        productCreatorId: product.stylistId, //need creator for item.
        contextType: '', //setting it to empty because either it will be a style or shopify item
        contextId: '', //setting it to empty because either it will be a style or shopify item
        contextTaffiId: '', //setting it to empty because either it will be a style or shopify item
        labels: product?.labels?.length ? product?.labels?.map((label) => label?.name || '') : [],
        stylistId: product?.stylistId,
        stylistEmail: product?.stylistEmail,
        stylistName: product?.stylistFirstName && product?.stylistFirstName + ' ' + (product?.stylistLastName || ''),
        userAuthState: user?.isUserAuthenticated ? USER_AUTH_STATE.AUTHENTICATED : USER_AUTH_STATE.GUEST,
        productTaffiUrl: `${process.env.REACT_APP_APP_ORIGIN}${isStyle ? PATH.STYLE_DETAIL : PATH.ITEM_DETAIL}/${
            product?.productTaffiId
        }`,
        recommendationSource: window?.location?.pathname,
    };
    if (isStyle) {
        let styleOnlyData = {
            ...trackData,
            items: {},
        };
        if (product?.items?.length) {
            let structuredItem = getItemStructure(product?.items);
            styleOnlyData = {
                ...styleOnlyData,
                items: structuredItem,
            };
        }
        const globalState = store.getState();
        const stitcher = globalState.configuration?.stitcher;
        const styleLayoutVersion =
            (stitcher.dynamicLayoutVersion === DynamicLayoutVersion.v2 &&
                product?.items?.every((item: any) => item?.category && item?.images?.length)) ||
            (product?.stylistId === process.env.REACT_APP_SHOPIFY_STYLIST_ID && !product.value?.length)
                ? DynamicLayoutVersion.v2
                : DynamicLayoutVersion.v1;

        trackData = { ...styleOnlyData, styleLayoutVersion };
    } else {
        trackData = {
            ...trackData,
            currency: product?.currency,
            price: product?.price,
            storeProductId: product?.storeProductId,
            storeUrl: product?.url,
            store: product?.items[0]?.store,
        };
    }
    return trackData;
};
